module.exports = __webpack_public_path__ + "d8a50121664679852049ca8556036fc6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/reading/book-covers/book-5.png
// module id = 2937
// module chunks = 0